import * as React from "react";

export default function ConvertLeadToPatientAction({ url }: { url: string }) {
  return (
    <a className="button-primary" href={url}>
      <span>{i18n["Page.PatientManagement.Profile.Convert"]}</span>
    </a>
  );
}
